import React, { useEffect, useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { RecordCamLoader } from 'app/pages/recordv1/RecordCamLoader';
import { RecorderBody } from 'app/pages/recordv1/RecorderBody';
import { RECORDING_STATUS } from 'app/pages/recordv1/types';
import useRecorder from 'app/pages/recordv1/useRecorder';
import {
  getAudioSettings,
  getVideoSettings,
} from 'app/pages/recordv1/utils/recorderSettings';
import { enableCamera } from 'app/pages/recordv1/utils/media';
import { useTranslation } from 'react-i18next';

export const CameraTelepromterPreview = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  const cameraStreamRef = useRef<MediaStream | null>(null);
  const [screenStream, setScreenStream] = useState<MediaStream | null>(null);

  const userSettings = {
    audioSource: { label: 'Default', value: 'default' },
    videoSource: { label: 'Default', value: 'default' },
    videoQuality: 'high',
  };

  const audioSettings = getAudioSettings(userSettings);
  const videoSettings = getVideoSettings(userSettings);

  const stopAllStreams = async () => {
    if (cameraStreamRef.current) {
      cameraStreamRef.current.getTracks().forEach(track => track.stop());
      cameraStreamRef.current = null;
    }
    if (screenStream) {
      screenStream.getTracks().forEach(track => track.stop());
    }
  };

  const startRecording = async () => {
    const stream = await enableCamera(audioSettings, videoSettings);
    if (stream) {
      cameraStreamRef.current = stream;
      setScreenStream(stream);
    }
  };

  useEffect(() => {
    startRecording();
    return () => {
      stopAllStreams();
    };
  }, []);

  const handleGoToRecordHome = () => {
    history.push('/profile/teleprompter/add');
  };

  const { status, countdown } = useRecorder({
    canvasRef,
    videoRef,
    screenStream: screenStream as MediaStream,
    stopAllStreams,
    shouldStartCountdown: false,
    handleGoToRecordHome,
  });

  return (
    <div style={{ position: 'relative' }}>
      {status === RECORDING_STATUS.IDLE && (
        <RecordCamLoader text={t('Loading camera')} />
      )}

      <RecorderBody
        videoRef={videoRef}
        canvasRef={canvasRef}
        countdown={countdown}
        status={status}
        teleprompter={<></>}
      />
    </div>
  );
};
